import * as tslib_1 from "tslib";
import store from '../store/store';
import { updateUserConfiguration } from 'owa-options-core';
import { getUserConfiguration } from 'owa-session-store';
import { action, select } from 'satcheljs/lib/legacy';
import { setBit } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
export default select({
    optionState: function () { return store; },
    viewStateConfiguration: function () { return getUserConfiguration().ViewStateConfiguration; },
})(function saveSenderImageOptionFull(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, viewStateConfiguration;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, viewStateConfiguration = state.viewStateConfiguration;
                    return [4 /*yield*/, saveSenderImageOption(optionState.showSenderImageInListView, viewStateConfiguration)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
var saveSenderImageOption = action('saveSenderImageOption')(function saveSenderImageOption(isEnabled, viewStateConfiguration) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setBit(!isEnabled, 8 /* HideSenderImage */);
                    return [4 /*yield*/, updateUserConfiguration([
                            {
                                propertyName: 'ListViewBitFlags',
                                propertyType: 'Integer32',
                                propertyValue: "" + viewStateConfiguration.ListViewBitFlags,
                            },
                        ], 'OWA.ViewStateConfiguration')];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
export var onSenderImageToggle = select({
    viewStateConfiguration: function () { return getUserConfiguration().ViewStateConfiguration; },
})(function (isEnabled, state) {
    saveSenderImageOption(isEnabled, state.viewStateConfiguration);
});
//# sourceMappingURL=saveSenderImageOption.js.map